<template lang="pug">
el-collapse-item(name='informacaoEspecial')
    template(slot='title')
        h2.collapse-titulo {{ $t('mensagens.territorio.territorioAr.upload.title') }}

    .collapse-conteudo
        InformacaoEspecial(
            @add='onAdd'
            @remover='onRemover'
            :layers='layers'
            :geometria='geometria'
            :informacoes='informacoes'
            :codigoLyra='codigoLyra'
            :mostrar-titulo='false'
        )
</template>

<script>
import InformacaoEspecial from '@/components/territorio/InformacaoEspecial.vue';

export default {
    name: 'InformacaoEspecialCollapse',
    components: {
        InformacaoEspecial
    },
    props: {
        layers: {
            type: Array,
            default: () => []
        },
        geometria: {
            type: Object,
            default: () => ({})
        },
        informacoes: {
            type: Object,
            default: () => ({})
        },
        codigoLyra: {
            type: String,
            default: ''
        }
    },
    methods: {
        onAdd(layer) {
            this.$emit('add', layer);
        },
        onRemover(index) {
            this.$emit('remover', index);
        }
    }
};
</script>

<style lang="scss" scoped>
.collapse-titulo {
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    margin-left: 20px;
    color: #3b3b3b;
}

.collapse-conteudo {
    padding: 16px;
}
</style>
